// material
import { CircularProgress, Box, Stack, Skeleton } from '@mui/material'
// redux
import NoNotifications from 'pages/NoNotifications'
import { UIContractState as Guarantee } from '../../@types/UIContractState'
import { useNavigate } from 'react-router'
import { PATH_DASHBOARD } from 'routes/paths'
import Page from 'components/Page'
import { Table, TableContainer } from './styles/MyTasks.styles'
import TaskCounter from './TaskCounter'
import HeadingTitle from './HeadingTitle'
import { getTaskId, useMyTasks } from 'hooks/useMyTasks'
import { fDateWithTimeZone } from 'utils/formatTime'
import { displayUserReadableAmount } from 'components/request-action/sections/forms/utils'

// Skeleton loader for tasks table
const TasksSkeleton = () => (
  <Box sx={{ p: 2 }}>
    <Stack spacing={2}>
      {Array.from({ length: 5 }).map((_, index) => (
        <Box
          key={index}
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(6, 1fr)',
            gap: 2,
            p: 2,
            backgroundColor: '#f9f9f9',
            borderRadius: 1,
            border: '1px solid #e0e0e0'
          }}
        >
          {Array.from({ length: 6 }).map((_, colIndex) => (
            <Skeleton key={colIndex} variant="text" width="100%" height={16} />
          ))}
        </Box>
      ))}
    </Stack>
  </Box>
)

// ----------------------------------------------------------------------

export default function MyTasks() {
  const navigate = useNavigate()
  const { myTasks, isLoading } = useMyTasks()
  return (
    <>
      <Page title="My Tasks" sx={{ margin: '0 24px 0 18px', paddingTop: '8px' }}>
        {isLoading && (
          <TasksSkeleton />
        )}
        <Box sx={{ marginBottom: '18px' }}>
          <HeadingTitle>My Tasks</HeadingTitle>
        </Box>
        <Box sx={{ marginBottom: '18px' }}>
          <TaskCounter type="my-task" rows={myTasks} />
        </Box>
        {myTasks && myTasks.length > 0 && (
          <TableContainer>
            <Table data-testid="my-tasks">
              <thead>
                <tr>
                  <th>Request Type</th>
                  <th>Guarantee ID</th>
                  <th>Related To</th>
                  <th>Currency</th>
                  <th>Value</th>
                  <th>Request Date</th>
                </tr>
              </thead>
              <tbody>
                {myTasks.length > 0 &&
                  myTasks?.map((row: Guarantee) => (
                    <tr
                      key={getTaskId(row)}
                      onClick={() =>
                        navigate(`${PATH_DASHBOARD.general.guarantee}/${getTaskId(row)}`)
                      }
                      data-testid={getTaskId(row)}
                    >
                      <td>{getRequestType(row)}</td>
                      <td>{getTaskId(row)}</td>
                      <td>{row?.TriContractState?.applicants?.[0]?.commonName}</td>
                      <td>{row?.TriContractState?.amount?.currencyCode}</td>
                      <td>
                        {row?.TriContractState?.amount &&
                          displayUserReadableAmount(row?.TriContractState?.amount)}
                      </td>
                      <td>
                        {row?.TriContractState?.eventTimestamp?.includes('UTC' || 'utc')
                          ? fDateWithTimeZone(row?.TriContractState?.eventTimestamp)
                          : row?.TriContractState?.eventTimestamp}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </TableContainer>
        )}
        {!isLoading && myTasks?.length === 0 && <NoNotifications title="No Tasks" type="tasks" />}
      </Page>
    </>
  )
}

const getRequestType = (guarantee: Guarantee) => {
  let requestType
  guarantee?.businessUnitActionContext?.[0]?.availableActions?.forEach((av: any) => {
    if (
      (av.action !== 'EXECUTE' &&
        ['APPROVE', 'PROPOSE'].includes(av.action) &&
        av.workflowTaskLabel === 'pending') ||
      (av.action === 'EXECUTE' && av.workflowTaskLabel === 'pending')
    )
      requestType = av.workflowTaskActionDisplay
  })
  return requestType
}
